export default {
      id: "pdf-usage",
      viewBox: "0 0 28 32",
      url: __webpack_public_path__ + "img/icons.1563a6ab.svg#pdf",
      toString: function () {
        return this.url;
      }
    }